/*=============================================== NavBottom component ===============================================*/

import { useLocation } from "react-router-dom"
import { Button, slugify } from "tsx-library-julseb"

import { StyledNavBottom } from "./styles"

import { allPages } from "data"

const NavBottom = () => {
    const location = useLocation().pathname
    const componentName = location.split("/")[2]

    const pageComponent =
        location.split("/").length === 3
            ? allPages.find(
                  component =>
                      slugify(component.title) === slugify(componentName)
              )
            : undefined
    const pageIndex = pageComponent ? allPages.indexOf(pageComponent) : 0

    const prevPage = allPages[pageIndex - 1]
    const nextPage =
        location !== "/helpers/hooks" ? allPages[pageIndex + 1] : allPages[0]

    return (
        <StyledNavBottom>
            {location === "/" ? (
                <span />
            ) : (
                <Button
                    to={
                        location === "/getting-started"
                            ? "/"
                            : location === "/styles/colors"
                            ? "/getting-started"
                            : `/${slugify(prevPage.category)}/${slugify(
                                  prevPage.title
                              )}`
                    }
                    variant="transparent"
                    icons={{
                        left: "chevron-left",
                    }}
                    noPadding
                >
                    {location === "/getting-started"
                        ? "Home"
                        : location === "/styles/colors"
                        ? "Getting started"
                        : prevPage.title}
                </Button>
            )}

            {location === "/helpers/hooks" ? (
                <span />
            ) : (
                <Button
                    to={
                        location === "/"
                            ? "/getting-started"
                            : location === "/getting-started"
                            ? "/styles/colors"
                            : `/${slugify(nextPage.category)}/${slugify(
                                  nextPage.title
                              )}`
                    }
                    variant="transparent"
                    icons={{
                        right: "chevron-right",
                    }}
                    noPadding
                >
                    {location === "/"
                        ? "Getting started"
                        : location === "/getting-started"
                        ? "Colors"
                        : nextPage.title}
                </Button>
            )}
        </StyledNavBottom>
    )
}

export default NavBottom
